// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProjectCurrency Model belongsTo relations 1`] = `
Array [
  "Project",
  "Currency",
]
`;
